// extracted by mini-css-extract-plugin
export default {"root":"IEEEFooter_root__fkC2i","copyright":"IEEEFooter_copyright__7iLVy","links":"IEEEFooter_links__hG24x","link":"IEEEFooter_link__cumMB"};